// D68 (16 Oct 2026, CONTROL D68 §4): "Completa tu ritual" in the cart drawer and cart page. When the bag holds only GUT
// or only CALM, offer the other one. Shopify checkout takes no custom upsell on this plan, so the offer lives here.
// Prices are real: the $89.90 pair line shows only when the add produces the Appstle Combo pair, which is the single
// monthly line (plan 5256347811, quantity 1) re-tagged with the Combo widget's line properties plus the other product,
// tagged the same way, at $49.90 + $49.90. A plain monthly pair is $99.80 (live cart probe, 16 Oct). Every other case
// shows the added product's own price. Data: snippets/f-ritual-cart-data.liquid. No claims in this block.
// GUT's handle comes from the data (settings.f_product), never a literal: the live handle is not the original one.
export const otherOf=data=>{const g=data?.gut;return g&&g!=='-'?{[g]:'calm',calm:g}:{};};
export const PAIR_CENTS=8990,PLAN_CENTS=4990;
// Pure: which offer, if any, fits this cart. Exported for scripts/check-ritual-cart.mjs.
export function ritualOffer(cart,data){
  if(!cart||!data||!Array.isArray(cart.items))return null;
  const OTHER=otherOf(data);
  const lines=cart.items.filter(i=>Object.hasOwn(OTHER,i.handle));
  const handles=[...new Set(lines.map(i=>i.handle))];
  if(handles.length!==1)return null;
  if(cart.items.some(i=>i.properties&&i.properties._appstle_bundles_type))return null;
  const have=handles[0],add=OTHER[have],product=data.products?.[add];
  if(!product||!product.available||!product.variant)return null;
  const onPlan=l=>l.selling_plan_allocation?.selling_plan?.id===data.plan;
  const qty=lines.reduce((s,l)=>s+l.quantity,0);
  if(lines.length===1&&qty===1&&onPlan(lines[0])&&product.monthly!=null){
    // The $89.90 line holds only while both plan prices are $49.90 (the Combo takes $9.90 off the pair).
    const exact=lines[0].original_line_price===PLAN_CENTS&&product.monthly===PLAN_CENTS;
    return {mode:'pair',have,add,product,line:lines[0],exact,price:exact?PAIR_CENTS:product.monthly};
  }
  if(lines.some(onPlan)&&product.monthly!=null)return {mode:'monthly',have,add,product,price:product.monthly};
  return {mode:'once',have,add,product,price:product.price};
}
const el=typeof document==='undefined'?null:document.getElementById('f-ritual-cart-data');
if(el){
  const data=JSON.parse(el.textContent);
  const body=document.body,es=body.dataset.lang==='es',t=(a,b)=>es?a:b,base=(body.dataset.root||'/').replace(/\/?$/,'/');
  const money=c=>new Intl.NumberFormat(es?'es-US':'en-US',{style:'currency',currency:'USD'}).format(c/100);
  const name=h=>h==='calm'?'CALM':'GUT';
  const api=async(endpoint,payload)=>{const r=await fetch(base+endpoint,{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify(payload)});
    const d=await r.json().catch(()=>({}));if(!r.ok)throw Error(typeof d.description==='string'?d.description:t('No se pudo actualizar la bolsa.','Could not update your bag.'));return d;};
  const node=(tag,text,cls)=>{const n=document.createElement(tag);if(text!=null)n.textContent=text;if(cls)n.className=cls;return n;};
  let busy=false;
  async function add(offer,note){
    if(busy)return;busy=true;note.textContent=t('Añadiendo…','Adding…');
    try{
      if(offer.mode==='pair'){
        // The Combo discount keys on the bundle's own id (the widget sends the same one on every add), not a fresh one.
        const props={'_appstle-bb-id':data.combo.bb,'__appstle-bb-name':data.combo.name,'_appstle_bundle_combo_id':data.combo.id,'_appstle_bundles_type':data.combo.type};
        await api('cart/change.js',{id:offer.line.key,quantity:1,selling_plan:data.plan,properties:{...(offer.line.properties||{}),...props}});
        await api('cart/add.js',{items:[{id:offer.product.variant,quantity:1,selling_plan:data.plan,properties:props}]});
      }else{
        const item={id:offer.product.variant,quantity:1};if(offer.mode==='monthly')item.selling_plan=data.plan;
        await api('cart/add.js',{items:[item]});
      }
      note.textContent='';
    }catch(error){note.textContent=error.message;}
    finally{busy=false;document.dispatchEvent(new CustomEvent('f:cart:reload'));}
  }
  document.addEventListener('f:cart:rendered',event=>{
    const offer=ritualOffer(event.detail?.cart,data);
    for(const container of document.querySelectorAll('[data-cart-content]')){
      container.querySelector('.ritual-cart')?.remove();if(!offer)continue;
      const box=node('div',null,'ritual-cart');box.dataset.ritualMode=offer.mode;
      if(offer.product.image){const img=node('img');img.src=offer.product.image;img.alt='';img.width=64;img.height=64;img.loading='lazy';box.append(img);}
      const copy=node('div',null,'ritual-cart-copy');
      copy.append(node('strong',t(`Completa tu ritual: agrega ${name(offer.add)}`,`Complete your ritual: add ${name(offer.add)}`)));
      const line=offer.mode==='pair'&&offer.exact?t('$89.90 al mes las dos, con suscripción','$89.90 a month for both, with subscription')
        :offer.mode==='once'?`${money(offer.price)} · ${t('compra única','one-time')}`:`${money(offer.price)} ${t('al mes, con suscripción','a month, with subscription')}`;
      copy.append(node('span',line,'ritual-cart-price'));
      const note=node('span',null,'ritual-cart-note');note.setAttribute('role','status');copy.append(note);
      const button=node('button',t(`Agregar ${name(offer.add)}`,`Add ${name(offer.add)}`),'button small');button.type='button';
      button.addEventListener('click',()=>add(offer,note));
      box.append(copy,button);
      const total=container.querySelector('.f-cart-total');total?container.insertBefore(box,total):container.append(box);
    }
  });
  // D76: "Llévate las dos" (snippets/f-pair-offer): GUT and CALM on the monthly plan, both tagged as the Combo in one add,
  // then open the bag. The Combo prices the pair at $89.90 (hosted real-cart test, 16 Oct).
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-f-pair-add]');if(!button||busy)return;
    const note=button.parentElement.querySelector('[role="status"]')||node('span');
    const g=data.products?.[data.gut],c=data.products?.calm;
    if(!g?.variant||!c?.variant){note.textContent=t('No se pudo agregar.','Could not add.');return;}
    busy=true;button.disabled=true;note.textContent=t('Añadiendo…','Adding…');
    const props={'_appstle-bb-id':data.combo.bb,'__appstle-bb-name':data.combo.name,'_appstle_bundle_combo_id':data.combo.id,'_appstle_bundles_type':data.combo.type};
    try{await api('cart/add.js',{items:[g,c].map(p=>({id:p.variant,quantity:1,selling_plan:data.plan,properties:props}))});note.textContent='';document.querySelector('[data-cart]')?.click();}
    catch(error){note.textContent=error.message;}
    finally{busy=false;button.disabled=false;document.dispatchEvent(new CustomEvent('f:cart:reload'));}
  });
  // The cart page may render before this module loads; ask for one more render so the block appears there too.
  if(document.querySelector('.f-cart-page'))document.dispatchEvent(new CustomEvent('f:cart:reload'));
}
